import { useQuery } from '@tanstack/react-query';

import { customInstance } from '@/api/mutator/custom-instance-new';

export type AssistantStatus = {
	enabled: boolean;
};

/** Long enough to keep this request rare, short enough that a beta invite lands in the same session. */
const STATUS_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * Reports whether the AI assistant is available **to this user**. The API combines
 * its Bedrock configuration with the `assistant` feature flag of the user. The UI
 * hides the assistant entry points when the answer is false. A failed request also
 * counts as disabled, so the feature stays hidden when the endpoint is down.
 *
 * The answer is no longer cached forever, because it is now per user. An operator
 * who adds someone to the beta allowlist must not have to ask them to reload the app.
 */
export function useAssistantStatus() {
	return useQuery({
		queryKey: ['assistant', 'status'],
		queryFn: () => customInstance<AssistantStatus>({ url: '/assistant/status', method: 'GET' }),
		staleTime: STATUS_STALE_TIME_MS,
		retry: false,
	});
}
